import React, { useEffect, useState, useRef } from 'react'
import { Message } from '@cx/ui'

const useBindCaptcha = (id: string) => {
  const captcha = useRef<any>()
  const resolveRef = useRef<any>()
  const [token, setToken] = useState<string>()

  const initCaptcha = () => {
    captcha.current = new (window as any).SCaptcha({
      businessid: '0195ef4f-b1f8-749e-9ffd-6945a3b77849',
    })
    captcha.current!.bind(`#${id}`.replace(/:/g, '\\:'), (action: any, data: any) => {
      if (action === 'finished') {
        captcha.current.reset()
        if (data) {
          setToken(data)
          resolveRef.current(data)
        } else {
          Message.error('验证失败')
        }
      }
    })
    const oldStart = captcha.current.start.bind(captcha.current)
    captcha.current.start = (e: any) => {
      oldStart(e)
      return new Promise((resolve) => {
        resolveRef.current = resolve
      })
    }
  }

  useEffect(() => {
    initCaptcha()
  }, [])
  return [captcha, token] as [any, string]
}

export default useBindCaptcha
